import { createDisplaySetSplitRules, displaySetRules } from './displaySetRules.js';
export const compiledDisplaySetRules = createDisplaySetSplitRules(displaySetRules);
export const defaultDisplaySetSplitRules = compiledDisplaySetRules;
